var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"message"}},[_c('div',{staticClass:"message",class:_vm.getClass(_vm.type)},[_vm._v(" "+_vm._s(_vm.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }